/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { editUserData, getUserById } from './user.edit.thunk';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  user: {},
  resetUserProfile: false,
  error: undefined,
};

/* Slice */
export const userEditSlice = createSlice({
  name: 'userEdit',
  initialState,
  reducers: {
    updateUser(state, action) {
      state.user = { ...state.user, ...action.payload };
    },
    resetUser(state) {
      state.status = ThunkStatus.IDLE;
      state.user = {};
      state.error = undefined;
      state.resetUserProfile = false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getUserById.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.user = action.payload;
        state.error = undefined;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.error = action?.error?.message;
      })
      .addCase(editUserData.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(editUserData.fulfilled, (state) => {
        state.status = ThunkStatus.SUCCEEDED;
        // state.resetUserProfile = true;
        state.error = undefined;
      })
      .addCase(editUserData.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.error = action?.error?.message;
      });
  },
});

/* Selectors */
const selectUserEdit = state => state[userEditSlice.name];
export const selectUser = createSelector(selectUserEdit, s => s.user);
export const selectStatus = createSelector(selectUserEdit, s => s.status);
export const selectResetUser = createSelector(selectUserEdit, s => s.resetUserProfile);

/* Actions */
export const { updateUser, resetUser } = userEditSlice.actions;
